import { motion } from "framer-motion";
import { Logo } from "./Brand";

const LINKS = [
  ["#drivers", "For drivers", "nav-drivers-link"],
  ["#how-it-works", "How it works", "nav-how-link"],
];

export const Nav = () => (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200/70"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-10 h-[72px] flex items-center justify-between">
      <Logo />
      <nav className="hidden md:flex items-center gap-8">
        {LINKS.map(([href, label, id]) => (
          <a key={href} href={href} data-testid={id} className="relative text-sm font-semibold text-slate-600 hover:text-[#13296B] transition-colors after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#2F7FF0] after:transition-[width] after:duration-300 hover:after:w-full">
            {label}
          </a>
        ))}
      </nav>
      <a
        href="#signup"
        data-testid="marketshipt-nav-waitlist-btn"
        className="rounded-full bg-[#2F7FF0] text-white text-sm font-bold px-5 py-2.5 shadow-[0_8px_24px_-8px_rgba(47,127,240,0.7)] hover:bg-[#13296B] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
      >
        Get early access
      </a>
    </div>
  </motion.header>
);
